/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import isArray from 'lodash/isArray';
import { EntitySegment, SEGMENT_CONDITION_AND, SEGMENT_CONDITION_OR } from '../../../../Services/segmentation';
import { SegmentRule } from '../../defs/SegmentRule.defs';
import { SegmentRuleset } from '../../defs/SegmentRuleset.defs';
import { UISegmentData } from '../../defs/UISegmentData.defs';
import { createRulesets, defaultRulesets } from '../CreateRulesets/CreateRulesets';

/**
 * Function to refactor the data returned by the API so it can be used in the UI.
 * @param {Segment} apiData The segment data for the API.
 * @export
 * @returns {UISegmentData} Refactored API data to be used in the Segment builder.
 */
export function formatFromAPI(apiData: EntitySegment): UISegmentData {
  const { code: segmentId, conditions, description: segmentDescription, name: segmentName } = { ...apiData };

  const rules = (conditions || defaultRulesets) as SegmentRuleset;

  const rulesetOperator = Object.keys(rules).includes(SEGMENT_CONDITION_AND)
    ? SEGMENT_CONDITION_AND
    : SEGMENT_CONDITION_OR;
  // @ts-ignore.
  const rulesets: Array<SegmentRule> = rules[rulesetOperator];

  if (!isArray(rulesets)) {
    throw new Error(`Invalid ruleset data.`);
  }

  return {
    segmentDescription,
    segmentId,
    segmentName,
    segmentRules: {
      operator: rulesetOperator,
      rulesets: createRulesets(rulesets),
    },
  };
}
